// extracted by mini-css-extract-plugin
export default {"widgetGap":".5rem","widgetView":"WidgetView_widgetView__m-lSj","widgetViewColumn":"WidgetView_widgetViewColumn__en0hf","widgetViewRow":"WidgetView_widgetViewRow__IpcjG"};